import { render, staticRenderFns } from "./SelectContainerType.vue?vue&type=template&id=36ef1af8&lang=pug&"
import script from "./SelectContainerType.vue?vue&type=script&lang=js&"
export * from "./SelectContainerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports